const link_list = {
    routePath: 'notifications',
    actionName: 'count',
    iconClass: 'fa-solid fa-circle-exclamation',
    title: 'My Active Notification',
    search: {
        read: {
            key: 'read',
            value: 0,
        },
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }